import React from 'react';
import { Box, SimpleGrid, Heading } from '@chakra-ui/react';
import Wrapper from '@components/atoms/Wrapper';
import Media from '@components/atoms/Media';
import RichText from '@components/atoms/RichText';
import Link from '@components/atoms/Link';
import HeaderFont from '@components/atoms/HeaderFont';
import { dataLayerClick } from '@helpers/dataLayerPush';

const RoutineIdentifierRow = ({
  title = ``,
  step = ``,
  image = ``,
  content = ``,
  buttonText = ``,
  buttonLink = ``,
  bgImage = ``,
  bgColour = ``
}) => {
  return (
    <Box
      bg={`url(${bgImage.localFile.url}) no-repeat center top ${
        bgColour.startsWith(`#`) ? bgColour : `#${bgColour}`
      }`}
      backgroundSize={{ base: `200%`, md: `auto` }}>
      <Wrapper narrow>
        <Box pt="10">
          <HeaderFont
            textTransform="uppercase"
            color="purple.600"
            fontWeight="900"
            fontSize={{ base: `2.25rem`, md: `4.35rem` }}
            fontStyle="italic"
            transform="rotate(-5deg)"
            lineHeight="1">
            {step}
          </HeaderFont>
          <Heading
            as="h2"
            fontSize={{ base: `14vw`, md: `8xl` }}
            textTransform="uppercase"
            color="purple.600"
            fontWeight="900"
            fontStyle="italic"
            transform="rotate(-5deg)"
            lineHeight="1"
            pb="0">
            {title}
          </Heading>
        </Box>
        <SimpleGrid
          columns={{ base: 1, md: 2 }}
          spacing="14"
          py={{ base: `14`, md: `20` }}>
          <Box px="6">
            <Media
              width={{ base: `100%`, md: `auto` }}
              height="auto"
              objectFit="cover"
              display="inline-flex"
              media={image}
            />
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            justifyContent="center">
            <RichText data={content} />
            {buttonLink && buttonLink.length > 0 && (
              <Link
                variant="purpleButton"
                display="inline-flex"
                href={buttonLink}
                w="auto"
                textAlign="center"
                onClick={() => {
                  dataLayerClick({
                    event: `cta_click`,
                    clickText: buttonText,
                    clickUrl: buttonLink
                  });
                }}>
                <HeaderFont fontWeight="700">{buttonText}</HeaderFont>
              </Link>
            )}
          </Box>
        </SimpleGrid>
      </Wrapper>
    </Box>
  );
};

export default RoutineIdentifierRow;
